import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps } from '@mui/material'
import styled from 'styled-components'
import {
  Box,
  Divider,
  DialogContent,
  Typography,
  IconButton,
  Icon,
  BoxPropsType,
} from '@astro-ui/components'
import theme from '@astro-ui/theme'

const ARROW_LEFT_CLOSE_ICON = 'arrow-left'

export type DrawerPropsType = MuiDrawerProps & {
  width?: BoxPropsType['width']
  title?: string
  titleProps?: React.CSSProperties
  withHeader?: boolean
  headerJustifyContent?: BoxPropsType['justifyContent']
  closeIcon?: 'plus' | 'arrow-left'
  onClose?: () => void
}

const Drawer = ({
  children,
  title = '',
  titleProps,
  width = {
    mobile: '100vw',
    tablet: '40vw',
  },
  withHeader = true,
  headerJustifyContent = 'space-between',
  closeIcon = 'plus',
  onClose,
  sx,
  ...rest
}: DrawerPropsType) => {
  const isBackCloseIcon = closeIcon === ARROW_LEFT_CLOSE_ICON

  return (
    <DrawerBase anchor="right" sx={{ zIndex: theme.zIndex.modal, ...(sx || {}) }} {...rest}>
      <Box
        className="drawer-wrapper"
        width={width}
        height="100%"
        display="flex"
        flexDirection="column"
        flex="1 1 auto"
      >
        {withHeader && (
          <Box
            className="drawer-title"
            display="flex"
            justifyContent={headerJustifyContent}
            alignItems="center"
            gap={isBackCloseIcon ? '12px' : undefined}
            p={isBackCloseIcon ? '24px' : '16px 24px'}
            style={titleProps}
          >
            {onClose && isBackCloseIcon ? (
              <IconButton
                onClick={onClose}
                width="40px"
                height="40px"
                borderRadius="100px"
                bg="#FAFAFA"
              >
                <Icon icon="arrow-left" size={20} />
              </IconButton>
            ) : null}

            <Typography variant="h2">{title}</Typography>

            {onClose && closeIcon === 'plus' ? (
              <IconButton onClick={onClose} transform="rotate(45deg)">
                <Icon icon="plus" color="grey9" size={24} />
              </IconButton>
            ) : null}
          </Box>
        )}

        <Divider />

        <DialogContent>{children}</DialogContent>
      </Box>
    </DrawerBase>
  )
}

export default Drawer

export type DrawerBasePropsType = MuiDrawerProps

export const DrawerBase = styled(MuiDrawer)<DrawerBasePropsType>``
